import { serviceUser } from "../user";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";

export const getIdentityVerificationRequest = async (
  identityVerificationRequestId: string
): Promise<IIdentityVerificationRequestResponse> => {
  const response = await serviceUser.get<IIdentityVerificationRequestResponse>(
    `/identity-verification-request/${identityVerificationRequestId}`
  );
  return response.data;
};
